import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=0bdf403f&scoped=true"
import script from "./ListItem.vue?vue&type=script&lang=js"
export * from "./ListItem.vue?vue&type=script&lang=js"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=0bdf403f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf403f",
  null
  
)

export default component.exports